import React, { useRef, useState, useCallback } from 'react';
import { Volume2, VolumeX, Play, Pause } from 'lucide-react';

const HERO_VIDEO = (process.env.PUBLIC_URL || '') + '/assets/videos/hero.mp4';

export default function HeroImage() {
  const ref = useRef(null);
  const [muted, setMuted] = useState(true);
  const [playing, setPlaying] = useState(true);

  const toggleMute = useCallback((e) => {
    e.stopPropagation();
    const el = ref.current;
    if (!el) return;
    el.muted = !el.muted;
    setMuted(el.muted);
  }, []);

  const togglePlay = useCallback((e) => {
    e.stopPropagation();
    const el = ref.current;
    if (!el) return;
    if (el.paused) {
      el.play().catch(() => {});
      setPlaying(true);
    } else {
      el.pause();
      setPlaying(false);
    }
  }, []);

  return (
    <div className="lg:col-span-5 relative">
      <div className="absolute -top-6 -left-6 w-24 h-24 rounded-full bg-[#F4B93E] hidden sm:block wiggle" />
      <div className="absolute -bottom-8 -right-6 w-32 h-32 rounded-3xl bg-[#4FB3B8]/70 hidden sm:block floaty" />
      <div className="relative bg-[#2C3E50] rounded-3xl border-2 border-[#2C3E50] paper-shadow overflow-hidden">
        <video
          ref={ref}
          src={HERO_VIDEO}
          className="w-full h-[520px] object-cover object-center bg-[#2C3E50]"
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          onPlay={() => setPlaying(true)}
          onPause={() => setPlaying(false)}
        />

        {/* Overlay controls */}
        <div className="absolute top-3 right-3 flex gap-2">
          <button
            type="button"
            onClick={togglePlay}
            aria-label={playing ? 'Pause video' : 'Play video'}
            className="w-10 h-10 rounded-full bg-white/95 text-[#2C3E50] border-2 border-[#2C3E50] flex items-center justify-center hover:bg-[#F4B93E]"
          >
            {playing ? <Pause size={16} strokeWidth={3} /> : <Play size={16} strokeWidth={3} />}
          </button>
          <button
            type="button"
            onClick={toggleMute}
            aria-label={muted ? 'Unmute video' : 'Mute video'}
            className="w-10 h-10 rounded-full bg-white/95 text-[#2C3E50] border-2 border-[#2C3E50] flex items-center justify-center hover:bg-[#F4B93E]"
          >
            {muted ? <VolumeX size={16} strokeWidth={3} /> : <Volume2 size={16} strokeWidth={3} />}
          </button>
        </div>

        <div className="absolute bottom-4 left-4 right-4 bg-[#FFF8EC] rounded-xl border-2 border-[#2C3E50] p-3 flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-[#E64B2B] text-white flex items-center justify-center font-black">P</div>
          <div className="text-sm leading-tight">
            <div className="font-bold text-[#2C3E50]">Pikachu Classes &middot; A day in class</div>
            <div className="text-[#2C3E50]/70">See how our tutors bring learning home</div>
          </div>
        </div>
      </div>
    </div>
  );
}
